import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Layout, Menu } from "antd";
import {
  BsGear,
  BsGrid,
  BsBuilding,
  BsFillKeyFill,
  BsFillEyeFill,
  BsFillDiagram3Fill,
} from "react-icons/bs";
import {
  BellOutlined,
  MenuFoldOutlined,
  FileTextOutlined,
  MenuUnfoldOutlined,
  UsergroupAddOutlined,
  AuditOutlined,
  FileDoneOutlined,
  WifiOutlined
 
} from "@ant-design/icons";
import Icon from "@ant-design/icons";

const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const [openKeys, setOpenKeys] = useState("");

  const onCollapse = (isCollapsed) => {
    setCollapsed(isCollapsed);
  };

  const CustomTrigger = () =>
    collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />;

  const UsersSvg = () => (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.423 5.75419C11.7737 5.90817 12.0908 6.1221 12.37 6.39326C12.9789 6.98192 13.3128 7.76406 13.317 8.5939V10.8395C13.317 11.5222 12.7446 12.0768 12.0431 12.0768H8.56799C8.36877 12.5292 7.9072 12.8289 7.39652 12.8289H3.52437C2.82149 12.8289 2.25049 12.273 2.25049 11.5917V9.34743C2.25049 8.5176 2.58579 7.73545 3.19327 7.14543C3.47106 6.87427 3.78953 6.66034 4.14027 6.50636C3.73341 6.29652 3.38548 5.99402 3.12453 5.62066C2.80606 5.16554 2.6377 4.63412 2.6377 4.08225C2.6377 2.5711 3.90317 1.34201 5.45904 1.34201C6.25031 1.34201 6.99247 1.6595 7.52559 2.21682C7.73042 1.76715 8.05591 1.38153 8.47259 1.09402C8.95099 0.76426 9.51498 0.589844 10.1042 0.589844C11.6601 0.589844 12.9256 1.81893 12.9256 3.33008C12.9256 3.88331 12.7572 4.41473 12.4387 4.86985C12.1778 5.24321 11.8299 5.54571 11.423 5.75419ZM10.1042 1.55868C9.61599 1.55868 9.15862 1.74263 8.8149 2.07784C8.46977 2.41168 8.28038 2.8559 8.28038 3.33009C8.28038 3.80429 8.46977 4.2485 8.8149 4.58235C9.15862 4.91755 9.61599 5.10151 10.1042 5.10151C10.5924 5.10151 11.0498 4.91755 11.3935 4.58235C11.7373 4.2485 11.9281 3.80429 11.9281 3.33009C11.9281 2.8559 11.7387 2.41168 11.3935 2.07784C11.0498 1.74263 10.5924 1.55868 10.1042 1.55868ZM3.63379 4.08226C3.63379 3.60807 3.82319 3.16385 4.16831 2.83001C4.51204 2.4948 4.9694 2.31085 5.45763 2.31085C5.94586 2.31085 6.40322 2.4948 6.74694 2.83001C7.09207 3.16521 7.28147 3.60943 7.28147 4.08226C7.28147 4.55645 7.09207 5.00067 6.74694 5.33451C6.40322 5.66972 5.94586 5.85367 5.45763 5.85367C4.9708 5.85367 4.51204 5.66972 4.16691 5.33451C3.82319 5.00067 3.63379 4.55509 3.63379 4.08226ZM7.5873 11.7784C7.64061 11.7279 7.66867 11.6612 7.66867 11.5903V9.34744C7.66867 8.7874 7.4456 8.25734 7.04155 7.854L7.03734 7.84855C7.03313 7.8431 7.02612 7.83629 7.0191 7.82947C6.59962 7.42205 6.04545 7.19858 5.45762 7.19858C4.86978 7.19858 4.31561 7.42205 3.89613 7.82947C3.47665 8.2369 3.24656 8.77514 3.24656 9.34608V11.5903C3.24656 11.7375 3.37002 11.8574 3.52154 11.8574H7.39369C7.46665 11.8574 7.53539 11.8288 7.5873 11.7784ZM7.42176 6.88518C7.22113 6.73256 7.00508 6.60584 6.7764 6.50501C7.33337 6.21749 7.77951 5.75556 8.03625 5.19552C8.25231 5.42036 8.50484 5.60976 8.78402 5.75284C8.43329 5.90681 8.11482 6.12211 7.83703 6.39191C7.6813 6.54452 7.54241 6.7094 7.42176 6.88518ZM12.0403 11.1066C12.1918 11.1066 12.3153 10.9867 12.3153 10.8395V8.59391C12.3153 8.02297 12.0852 7.48473 11.6657 7.07731C11.2462 6.66988 10.692 6.44641 10.1042 6.44641C9.51637 6.44641 8.9608 6.67124 8.54272 7.07867C8.37577 7.23946 8.23828 7.42341 8.13166 7.62644C8.4824 8.13607 8.66759 8.72881 8.66759 9.34608V11.1066H12.0403Z"
        fill="rgb(175 190 200)"
      />
    </svg>
  );
  const UsersIcon = (props) => <Icon component={UsersSvg} {...props} />;

  const onOpenChange = (options) => {
    setOpenKeys(options[1]);
  };

  return (
    <Fragment>
      <Sider
        width="236"
        trigger={<CustomTrigger />}
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
      >
        <Menu
          theme="dark"
          mode="inline"
          openKeys={[openKeys]}
          onOpenChange={onOpenChange}
          selectedKeys={[location.pathname]}
          
        >
          <Menu.Item key="/dashboard" icon={<BsGrid />}>
            <Link to="/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="/organizations" icon={<BsBuilding />}>
            <Link to="/organizations">Organizations</Link>
          </Menu.Item>
          <Menu.Item key="/subscriptions" icon={<BellOutlined />}>
            <Link to="/subscriptions">Subscriptions</Link>
          </Menu.Item>

          <Menu.Item key="/plans" icon={<FileTextOutlined />}>
            <Link to="/plans">Plans</Link>
          </Menu.Item>
          <Menu.Item key="/serviceprovider" icon={<BsGear />}>
            <Link to="/serviceprovider">Service Providers</Link>
          </Menu.Item>         
          <SubMenu
            key="/roles-access-management"
            icon={<BsFillKeyFill />}
            title="Access Management"
          >
            <Menu.Item key="/roles-access-management">
              <Link to="/roles-access-management">
                {<BsFillDiagram3Fill />} Roles
              </Link>
            </Menu.Item>
            <Menu.Item key="/permissions">
              <Link to="/permissions">{<BsFillEyeFill />} Permissions</Link>
            </Menu.Item>
          </SubMenu>
          <Menu.Item key="/users" icon={<Icon component={UsersIcon} />}>
            <Link to="/users">Users</Link>
          </Menu.Item>
          <Menu.Item key="/configurations" icon={<BsGear />}>
            <Link to="/configurations">Configuration</Link>
          </Menu.Item>
          <Menu.Item key="/individual-landlord" icon={<FileTextOutlined />}>
            <Link to="/individual-landlord">Individual Landlords</Link>
          </Menu.Item>

          <SubMenu
            key="/reports"
            icon={<FileDoneOutlined />}
            title="Reports"
          >
            <Menu.Item key="/pickup_requests_reports">
              <Link to="/reports/Pickup-Requests">
                {<AuditOutlined />} Pickup Requests
              </Link>
            </Menu.Item>
            <Menu.Item key="/online_payment_report">
              <Link to="/reports/Online-Payments">{ <WifiOutlined />} Online Payments  </Link>
            </Menu.Item>
          </SubMenu>
        </Menu>
      </Sider>
    </Fragment>
  );
  // }
};

export default Sidebar;
